import Logger from '@Utils/Logger'

type SafeMediaPlayOptions = {
  context?: string
  onNotAllowedError?: () => void
}

const isDomExceptionWithName = (error: unknown, name: string): boolean => {
  return !!error && typeof error === 'object' && 'name' in error && (error as { name?: unknown }).name === name
}

export const safeMediaPlay = (mediaElement: HTMLMediaElement, options: SafeMediaPlayOptions = {}): void => {
  try {
    const playPromise = mediaElement.play()
    if (!playPromise) {
      return
    }

    playPromise.catch(error => {
      // Common and expected when a play() is immediately followed by pause()
      // or by a new load/seek that cancels the pending play.
      if (isDomExceptionWithName(error, 'AbortError')) {
        return
      }

      if (isDomExceptionWithName(error, 'NotAllowedError')) {
        options.onNotAllowedError?.()
        Logger.debug(`Media play prevented by browser policy${options.context ? ` (${options.context})` : ''}:`, error)
        return
      }

      Logger.debug(`Failed to play media${options.context ? ` (${options.context})` : ''}:`, error)
    })
  } catch (error) {
    Logger.debug(`Failed to call media.play()${options.context ? ` (${options.context})` : ''}:`, error)
  }
}
